import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import instance from "../../store/actions/instance";
import { setUser } from "../../store/actions/auth";

class AccountDeletionDialog extends Component {
  state = {
    error: false,
    word: "",
  };

  deleteAccount = async () => {
    this.setState({ loading: true });
    try {
      const res = await instance.post("/delete_account/", {});
      if (res.data.success) {
        this.setState({ loading: false });
        this.props.setUser();
        this.props.onClose();
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ loading: false });
  };
  render() {
    const { language, customTexts } = this.props;
    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };
    return (
      <Dialog
        open={true}
        onClose={() => this.props.onClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            maxWidth: 400,
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {language == "english" ? "Delete your account" : "مسح الحساب"}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText
            id="alert-dialog-description"
            style={{ textAlign: language == "english" ? "left" : "right" }}
          >
            
          </DialogContentText> */}
          <div style={{ textAlign: language == "english" ? "left" : "right" }}>
            {language == "english"
              ? "Are you sure you want to delete your account? You will lose all data associated with it."
              : "هل انت متأكد من حذف حسابك؟ سيتم مسح جميع البيانات المتعلقة بالحساب."}
          </div>
          <p
            className="mb-0 mt-3"
            style={{ textAlign: language == "english" ? "left" : "right" }}
          >
            {language === "arabic"
              ? "للمتابعة، قم بكتابة كلمة"
              : "To proceed, please type the word"}{" "}
            "
            <span className="bold">
              {language === "arabic" ? "حذف" : "Delete"}
            </span>
            " {language === "arabic" ? "ادناه" : "below"}
          </p>
          <TextField
            id="keyword"
            label={language == "english" ? "Type here" : "اكتب هنا"}
            fullWidth
            InputLabelProps={{
              style: inputLabelStyle,
              dir: language == "english" ? "ltr" : "rtl",
            }}
            InputProps={{
              dir: language == "english" ? "ltr" : "rtl",
            }}
            color="primary"
            className="my-4"
            onChange={(e) => this.setState({ word: e.target.value })}
            name="keyword"
            autoComplete="keyword"
            value={this.state.word}
            FormHelperTextProps={{
              style: {
                textAlign: language == "arabic" && "right",
                marginRight: language == "arabic" && 5,
              },
            }}
          />
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button
            onClick={() => this.deleteAccount()}
            style={{
              color:
                this.state.word.toLowerCase().includes("delete") ||
                this.state.word.toLowerCase().includes("حذف")
                  ? "red"
                  : "gray",
            }}
            disabled={
              !this.state.word.toLowerCase().includes("delete") &&
              !this.state.word.toLowerCase().includes("حذف")
            }
            loading={this.state.loading}
          >
            {language == "english" ? "Delete my account" : "حذف حسابي"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customTexts: state.store.store.settings.custom_texts,
    settings: state.store.store.settings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (key) => dispatch(setUser(key)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountDeletionDialog);
